module.exports = __webpack_public_path__ + "img/34_fineStaff_zb.07ccc021.png";